import React, { Component } from "react";
import AltruistLogo from "../assets/AltruistLogo";
import { Utils } from "../Utils";
import axios from "axios";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

interface State {
  stations: Array<any>;
  stationsOpen: boolean;
}

class Sidebar extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { stations: [], stationsOpen: true };
  }

  componentDidMount() {
    axios
      .get(Utils.BACKEND_BASE_URL + "station")
      .then((res) => this.setState({ stations: res.data }))
      .catch((err) => console.error("unable to fetch stations", err));
  }

  render() {
    const { isOpen, onClose } = this.props;
    const { stations, stationsOpen } = this.state;

    return (
      <aside
        className={`
          fixed inset-y-0 left-0 z-40 flex w-64 flex-col bg-white border-r border-gray-200
          transition-transform duration-200
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0
        `}
      >
        {/* Brand */}
        <a href="/" className="flex items-center gap-3 border-b border-gray-200 px-5 py-4">
          <AltruistLogo size={36} />
          <span className="text-lg font-semibold text-gray-800">ALTRUIST</span>
        </a>

        {/* Nav */}
        <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
          {/* Dashboard */}
          <a
            href="/"
            className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-brand-50 hover:text-brand-500 transition"
          >
            <i className="ti-home text-blue-500 text-base" />
            Dashboard
          </a>

          {/* Stations */}
          <div>
            <button
              onClick={() => this.setState({ stationsOpen: !stationsOpen })}
              aria-expanded={stationsOpen}
              className="flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-brand-50 hover:text-brand-500 transition"
            >
              <span className="flex items-center gap-3">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0-4 0" />
                  <path d="M12 2v4" /><path d="M12 18v4" />
                  <path d="M4.93 4.93l2.83 2.83" /><path d="M16.24 16.24l2.83 2.83" />
                  <path d="M2 12h4" /><path d="M18 12h4" />
                  <path d="M4.93 19.07l2.83-2.83" /><path d="M16.24 7.76l2.83-2.83" />
                </svg>
                Stations
              </span>
              <i
                className={`ti-angle-right text-xs transition-transform duration-200 ${
                  stationsOpen ? "rotate-90" : ""
                }`}
              />
            </button>
            <ul
              className={`transition-all duration-200 ${
                stationsOpen
                  ? "max-h-[50vh] overflow-y-auto overscroll-contain"
                  : "max-h-0 overflow-hidden"
              }`}
            >
              {stations.map((s: any, i: number) => (
                <li key={i}>
                  <a
                    href={"/station/" + s._id}
                    className="block rounded-md py-1.5 pl-11 pr-3 text-sm text-gray-600 capitalize hover:bg-gray-50 hover:text-brand-500 transition"
                  >
                    {s.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <a
            href="/about"
            className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-brand-50 hover:text-brand-500 transition"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
            About
          </a>

          {/* Contact */}
          <a
            href="/contact"
            className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-brand-50 hover:text-brand-500 transition"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <polyline points="22 6 12 13 2 6" />
            </svg>
            Contact
          </a>
        </nav>
      </aside>
    );
  }
}

export default Sidebar;
